<template>
  <transition
    leave-active-class="delay-200"
    enter-class="opacity-0"
    enter-to-class="opacity-100"
    leave-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-show="dimmed"
      class="transition-opacity duration-300 ease-in-out fixed inset-0 bg-black bg-opacity-75 z-10000"
      @click.self="$emit('click')"
    ></div>
  </transition>
</template>

<script>
export default {
  props: {
    dimmed: { type: Boolean, default: false },
  },
}
</script>
